import type { FC, ReactNode } from 'react';
import { Button } from 'antd';
import { TbRestore } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { SmallTooltip } from '@/shared/components/tooltips';

import WhitelabelUpdatedTag from '../WhitelabelUpdatedTag';

interface WhitelabelFieldLabelProps {
    children: ReactNode;
    label: string;
    onRevert?: () => void;
    updated?: boolean;
}

const WhitelabelFieldLabel: FC<WhitelabelFieldLabelProps> = ({
    children,
    label,
    onRevert,
    updated = false,
}): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <span
            data-whitelabel-field-label='true'
            style={{ alignItems: 'center', display: 'flex', height: '1.375rem', minWidth: 0, width: '100%' }}
        >
            <span style={{ alignItems: 'center', display: 'inline-flex', minWidth: 0 }}>
                {children}
                {updated ? <WhitelabelUpdatedTag /> : null}
            </span>
            <span aria-hidden='true' style={{ flex: '1 1 auto' }} />
            {updated && onRevert ? (
                <span style={{ alignItems: 'center', display: 'inline-flex', flex: 'none', marginLeft: '0.25rem' }}>
                    <SmallTooltip placement='top' title={`Undo changes to ${label}`}>
                        <Button
                            aria-label={`Undo changes to ${label}`}
                            icon={<TbRestore aria-hidden='true' size='0.875rem' />}
                            size='small'
                            style={{ color: token.colorTextTertiary }}
                            type='text'
                            onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                onRevert();
                            }}
                        />
                    </SmallTooltip>
                </span>
            ) : null}
        </span>
    );
};

export default WhitelabelFieldLabel;
